import React from "react";
import FilterItem from "../../assets/components/FilterItem";

export default function ReportCardFilters({ selected, onChange }) {
  return (
    <div className="w-100 mt-1 mb-4 d-flex">
      <FilterItem title="جدید" selected={selected === "New"} handleClick={() => onChange("New")} />
      <FilterItem title="آرشیو" selected={selected === "Archived"} handleClick={() => onChange("Archived")} />
    </div>
  );
}
